module.exports = __webpack_public_path__ + "images/2-h7f28107df72313cdaaab1c28fc400fdd.svg";